import '../base'; //Import template styles

import '../../styles/template/article.recipe.scss'; //Import scripts

import './../components/carousels/article-featured-products';